import {TabId} from '@blueprintjs/core';
import * as I from 'immutable';

import {ApiOrderableScene} from 'app/modules/Remote/Feature';
import {getLayerKeyForScene} from 'app/utils/imageryUtils';
import {ResolutionCategoryId} from 'app/utils/layers';
import * as layerUtils from 'app/utils/layerUtils';

// A lil helper to get the resolution category
export function getResolutionCategoryForScene(
  scene: I.ImmutableOf<ApiOrderableScene>
): ResolutionCategoryId | undefined {
  if (scene.get('sourceId').includes('MULTISPECTRAL')) {
    return 'data';
  }
  const layerKey = getLayerKeyForScene(scene);
  if (!layerKey) {
    return undefined;
  }
  const layer = layerUtils.getLayer(layerKey, true);
  return layer?.resolutionCategory;
}

// Check if a scene belongs to the given tab (data vs imagery)
export function isSceneInTab(
  scene: I.ImmutableOf<ApiOrderableScene> | undefined,
  tab: TabId
): boolean {
  if (!scene) return false;
  const resolutionCategory = getResolutionCategoryForScene(scene);
  return (tab === 'data') === (resolutionCategory === 'data');
}
